/** Admin staff accounts — distinct from `student.types.ts`, which describes app end-users. */

export const ADMIN_ACCOUNT_ROLES = ['super_admin', 'admin', 'moderator'] as const;
export type AdminAccountRole = (typeof ADMIN_ACCOUNT_ROLES)[number];

export const ADMIN_ACCOUNT_ROLE_LABELS: Record<AdminAccountRole, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  moderator: 'Moderator',
};

/** `invited` accounts exist but cannot sign in until they set a password. */
export type AdminAccountStatus = 'active' | 'invited' | 'suspended';

export interface AdminAccount {
  id: string;
  name: string;
  email: string;
  role: AdminAccountRole;
  status: AdminAccountStatus;
  twoFactorEnabled: boolean;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/** Invites always create a super_admin, so no role is sent. */
export interface CreateAdminInput {
  name: string;
  email: string;
}

export interface UpdateAdminInput {
  status: 'active' | 'suspended';
}
